import { DateISO, UserModel } from "src/app/model/general.model";
import { TowerModel } from '../../../model/tower.model';
import { LineModel } from '../../../model/line.model';
import { SpanModel } from '../../../model/span.model';
import { FormEntry } from './form.model';
import { OrderModel } from '../../../model/order.model';
import { Project } from '../../../model/project.model';
import { FormHeader } from '../../settings/model/form.model';

export const TASK_TYPE = {
  TOWER: 'TOWER',
  SPAN: 'SPAN',
} as const;

export type TaskType = keyof typeof TASK_TYPE;

const TASK_STATUS = {
  DRAFT: "DRAFT",
  IN_PROGRESS: "IN_PROGRESS",
  TO_ACCEPT: "TO_ACCEPT",
  CLOSED: "CLOSED",
  CANCELLED: "CANCELLED"
} as const;

export type TaskStatus = keyof typeof TASK_STATUS;

export const TASK_STATUS_ORDER = {
  DRAFT: 1,
  IN_PROGRESS: 2,
  TO_ACCEPT: 3,
  CLOSED: 4,
  CANCELLED: 5,
};

export interface Task {
  id: number;
  name: string;
  plannedExecutionDate: DateISO;
  status: TaskStatus;
  assignees: UserModel[];
  order: OrderModel;
  filters: string;
  form?: TaskForm;
  formValues?: TaskFormValues;
  type: TaskType;
  line: LineModel | null;
  span: SpanModel | null;
  tower: TowerModel | null;
  localVersion?: boolean;
  failureCount?: number;
  project: Project;
  createdOn: DateISO;
  createdBy: UserModel | null;
  modifiedOn: DateISO | null;
  modifiedBy: UserModel | null;
  assignedOn: DateISO | null;
  assignedBy: UserModel | null;
  assignedTo: UserModel | null;
  templateImplementationVersion: number;
  isValid: boolean;
  copiedFrom: number;

  historicalFailureCodes: string[];
  historicalFailuresFrom: DateISO;
  historicalFailuresTo: DateISO;
}



export type TaskForm = {
  id: number;
  templateFormId: number;
  templateFormVersion: number;
  name: string;
  entries: FormEntry[];
  formHeaders: FormHeader[];
}

export type TaskFormValues = {
  id: number;
  templateFormId: number;
  templateFormVersion: number;
  name: string;
  entryValues: FormEntry[];
  formHeaders: FormHeader[];
}

// type TowerTaskProps = {
//   type: typeof TASK_TYPE.TOWER;
//   tower: TowerModel
// }
//
// type LineTaskProps = {
//   type: typeof TASK_TYPE.LINE;
//   line: LineModel
// }
//
// type SpanTaskProps = {
//   type: typeof TASK_TYPE.SPAN;
//   span: SpanModel
// }
//
// export type Task = TowerTask | LineTask | SpanTask;
//
// type TowerTask = TaskProps & TowerTaskProps;
// type LineTask = TaskProps & LineTaskProps;
// type SpanTask = TaskProps & SpanTaskProps;

export interface TaskStatusChangeResponse {
  succeeded: number[];
  failed: number[];
}

export interface TaskMultiAcceptResponse {
  succeeded: TaskBase[];
  failed: TaskBase[];
}

export interface TaskAssignResponse {
  succeeded: Task[];
  failed: number[];
}

export interface TaskBase {
  id: number;
  name: string;
}

export enum TaskCopyErrorCode {
  TASK_COPY_CANT_EDIT = 'TASK_COPY_CANT_EDIT',
  TASK_COPY_INVALID_TYPE = 'TASK_COPY_INVALID_TYPE',
  TASK_COPY_DIFFERENT_SKMS = 'TASK_COPY_DIFFERENT_SKMS',
  TASK_COPY_INVALID_STATUS = 'TASK_COPY_INVALID_STATUS',
  TASK_COPY_VALIDATION_ERROR = 'TASK_COPY_VALIDATION_ERROR',
  TASK_COPY_INCOMPATIBLE_STRUCTURE = '   TASK_COPY_INCOMPATIBLE_STRUCTURE',
  TASK_COPY_OTHER = 'TASK_COPY_OTHER'
}

export interface TaskCopyError {
  errorCode: TaskCopyErrorCode;
  taskName: string;
  taskId: number
}
